export default {
  // 資產信息
  totalAsset: "總資產（可用餘額）",
  updated: "更新",

  // Tooltip提示
  assetBalanceTooltip:
    "地址總資產餘額是根據本系統已收錄的幣種價值，按地址持有的所有主幣和代幣折算USDT的總餘額",
  systemSupport: "系統當前已支持",
  supportedCurrencies: "317個幣種",
  tronSupport: "Tron鏈幣種數據當前僅支持TRX、USDT",

  // 黑名單標籤
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // Tron 數據計算
  tronCalculating: "Tron數據計算中，請稍後查看",

  // 彈窗標題
  assetBalanceChange: "總資產餘額變化",
};
